<template>
<div class="row items-end justify-between">
  <slot name="header">
    <h1 class="heading-2 q-mb-lg">{{ item.title }}</h1>
  </slot>
</div>
<div v-if="item.created_at || item.updated_at" class="item-header__info q-gutter-lg">
  <template v-if="$isDesktop">
    <strong v-if="referenceNumber">{{ referenceNumber }}</strong>
    <slot name="type" />
    <div v-if="item.created_at" class="text-neutral-80 row">
      <q-icon v-if="item.created_at" name="schedule" size="xs" color="neutral-40" class="q-mr-lg"
              aria-hidden="true" />
      <span>Aangemaakt: {{ $formatDateStandard(item.created_at) }}</span>
    </div>
    <div v-if="item.updated_at" class="text-neutral-80 row">
      <q-icon v-if="!item.created_at" name="schedule" size="xs" color="neutral-40" class="q-mr-lg"
              aria-hidden="true" />
      <span>Laatst bewerkt: {{ $formatDateStandard(item.updated_at) }}</span>
    </div>
  </template>
  <template v-else>
    <slot name="type" />
    <strong v-if="referenceNumber">{{ referenceNumber }}</strong>
  </template>
  <slot />
</div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    referenceNumber: {
      type: String,
      default: '',
    },
  },
}
</script>
